import * as MetadataMethods from './metadata';

export default {
	...MetadataMethods,
};
